import React, { useEffect, useState } from 'react'
import { SocialIcon } from 'react-social-icons'
import { Link, useNavigate } from 'react-router-dom'

function Footer() {


    const navigate = useNavigate()
    const currentUrl = window.location.pathname;

    const [headerLink, setHeaderLink] = useState({ path: '', state: false })

    useEffect(() => {
        if (headerLink.state) {
            navigate('/' + headerLink.path)
            setHeaderLink({})
        }
        // eslint-disable-next-line 
    }, [headerLink, currentUrl])

    return (
        <footer className='bg-[#2A2A42] text-gray-400 '>
            <div className='container mx-auto'>
                <div className='py-8 px-4 flex gap-4 items-center flex-col sm:flex-row'>
                    <div className='flex flex-col flex-[0.3]'>
                        <span className='text-2xl text-gray-300'>BlogCode</span>
                        <span> Get Your Blog Up and Running in Minutes</span>
                    </div>
                    <div className='flex items-center justify-between w-full flex-[0.9] flex-col sm:flex-row gap-5 sm:gap-0'>
                        <div className='flex gap-2 '>
                            <SocialIcon network='instagram' url="https://instagram.com/programmer_nimish" target='_blank' />
                            <SocialIcon network='x' url="https://twitter.com/BandhaNimish" target="_blank" />
                        </div>
                        <div className='flex gap-3 text-xl text-gray-300 items-center flex-col sm:flex-row'>
                            <span className='cursor-pointer'>{currentUrl === "/" ? <a href="#features">Features</a> : <span onClick={() => setHeaderLink({ path: '#features', state: true })}> Features</span>}</span>
                            <span className='cursor-pointer'>{currentUrl === "/" ? <a href="#pricing">Pricing</a> : <span onClick={() => setHeaderLink({ path: '#pricing', state: true })}> Pricing</span>}</span>
                            <Link to="/checkout" className='bg-[#2196f3] text-gray-100 py-2 px-4 tracking-wider rounded relative group overflow-hidden self-center mt-2 text-sm' >
                                <span className='inline-block'>Get BlogCode</span>
                                <span className='inline-block ml-2 transition-transform group-hover:translate-x-2'>→</span>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className='border-t border-gray-600 px-4 py-2'>&copy; 2024 BlogCode</div>
            </div>
        </footer>
    )
}

export default Footer